import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { ExchangeRateInfo } from './subcomponents/ExchangeRateInfo';
import FeeInfo from './subcomponents/FeeInfo';
import { List } from './subcomponents/List';
import SaveMoneyButton from './subcomponents/SaveMoneyButton';
import { ListItem } from './subcomponents/styles';
import { CalculatorFrameBottom } from '../Calculator/styles';

const FeePanelPureComponent = (props) => {
    const showExchangeRatio = props.exchangeRatio && Object.keys(props.exchangeRatio).length > 0 && props.exchangeRatioText;

    return (
        <CalculatorFrameBottom>
            <List>
                <ListItem>
                    <FeeInfo isBonus={props.isBonus} formName={props.formName} commissionInfo={props.commission} fromCurrencyIso={props.fromCurrencyIso} />
                </ListItem>
                {showExchangeRatio && (
                    <ListItem>
                        <ExchangeRateInfo
                            commissionInfo={props.commission}
                            fromCurrencyIso={props.fromCurrencyIso}
                            currencyToIso={props.currencyToIso}
                            amountFrom={props.amountFrom}
                            deliveryMethod={props.deliveryMethod}
                        />
                    </ListItem>
                )}
            </List>
            <SaveMoneyButton
                formName={props.formName}
                promoCodeFetchUrl={props.promoCodeFetchUrl}
                beforeSaveMoneyCodeSubmit={props.beforeSaveMoneyCodeSubmit}
                commissionInfo={props.commission}
            />
        </CalculatorFrameBottom>
    );
};

FeePanelPureComponent.propTypes = {
    formName: PropTypes.string.isRequired,
    countryToId: PropTypes.number,
    deliveryMethod: PropTypes.string,
    exchangeRatioText: PropTypes.any,
    exchangeRatio: PropTypes.object,
    commission: PropTypes.object,
    promoCodeFetchUrl: PropTypes.string.isRequired,
    fromCurrencyIso: PropTypes.string,
    feeComment: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    beforeSaveMoneyCodeSubmit: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        shouldArrive: state.messages.pageMessages.shouldArrive,
        countryToId: state.extra.toCountry?.id,
        deliveryMethod: state.extra.deliveryMethod,
        exchangeRatioText: state.extra.exchangeRatioText,
        exchangeRatio: state.extra.exchangeRatio,
        commission: state.extra.commission,
        feeComment: state.extra.feeComment,
    };
};

const FeePanel = connect(mapStateToProps)(FeePanelPureComponent);
export default FeePanel;
